<template>
    <b-form-group :invalid-feedback="invalidFeedback" :label="label" :label-for="formControlId">
        <!-- eslint-disable -->
        <textarea
            :id="formControlId"
            :name="formControlId"
            style="display: none;"
            @change="handleChange">
            {{ data[property] }}
        </textarea>
        <!-- eslint-enable -->
        <csp-ckeditor-reduced :textarea-id="formControlId"/>
    </b-form-group>
</template>

<script>
    import FormGroupMixin from './FormGroupMixin';

    export default {
        mixins: [FormGroupMixin],
        props: {
            nullIfEmpty: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: 'ckeditorReduced',
            },
        },
        methods: {
            handleChange() {
                const element = document.querySelector('#' + this.formControlId);
                this.data[this.property] = element.textContent;
            },
        },
    }
</script>
